import { render, staticRenderFns } from "./questionComponent.vue?vue&type=template&id=535d4671&scoped=true"
import script from "./questionComponent.vue?vue&type=script&lang=js"
export * from "./questionComponent.vue?vue&type=script&lang=js"
import style0 from "./questionComponent.vue?vue&type=style&index=0&id=535d4671&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d4671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535d4671')) {
      api.createRecord('535d4671', component.options)
    } else {
      api.reload('535d4671', component.options)
    }
    module.hot.accept("./questionComponent.vue?vue&type=template&id=535d4671&scoped=true", function () {
      api.rerender('535d4671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionComponent.vue"
export default component.exports